import Vue from "vue";
import Vuex from "vuex";
import appSalesTabStore from "./modules/appSalesTabStore";
import appTableStore from "./modules/appTableStore";
import CommonStore from "./modules/commonStore";
import AppForecastStore from "./modules/appForecastStore";
import UploadCsvStore from "./modules/uploadCsvStore";
import LabourPlanning from "./modules/labourPlanning";
import AccountsStore from "./modules/accountsStore";
// import appTable from "./modules/appTable";
import TicketsStore from "./modules/ticketsStore";
import SettingStore from "./modules/settingStore";
import networkConfig from "./modules/networkConfig";
import MonthlySchedulerStore from "./modules/monthlySchedulerStore";
import TicketDashboardStore from "./modules/ticketDashboardStore";
import UsersAndGroups from "./modules/usersAndGroups";
import SalesForecastStore from "./modules/SalesForecastStore";
import TrainingStore from "./modules/trainingStore";
import salesForecastStoreV2 from "./modules/salesForecastStoreV2";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		store_email: "",
		userRegistration: {
			full_name: "",
			email: "",
			company_name: "",
			contact_number: "",
			Address1: "",
			Address2: "",
			selected_country: "",
			selected_state: "",
			selected_city: "",
			selected_sector: "",
			zip_code: "",
			contact_number: "",
			start_date: "",
			start_date1: "",
			end_date: "",
			is_single_location: false,
			sales_analytics_and_forcasting: false,
			other_company_sector: "",
			more_store: "",
			all: false,
			expiry_management: false,
			inventory_management: false,
			loginUserDetails: {},
			outletData: {}
		},
		// salesTable: {
		// 	data: {
		// 		headingMain: [
		// 			{ value: "Store ID", colspan: 1 },
		// 			{ value: "Achievement", colspan: 3 },
		// 			{ value: "Target", colspan: 3 }
		// 		],
		// 		headings: [
		// 			"Store Name",
		// 			"This Year",
		// 			"Last Year",
		// 			"YoY %",
		// 			"Total YTD",
		// 			"Difference",
		// 			"Difference %"
		// 		],
		// 		rows: []
		// 	}
		// },
		show_login_and_freeTrial_model: false,
		toggle_login_and_freeTrial_tab: false,
		acount_type_tab: false,
		user_information_tab: true,
		finish_setup_tab: false,
		filled_user_information: false,
		filled_account_type: false,
		active_task_type_tab: 'ASSIGNED_TASKS',
		designations: [],
		timesheet_summary: {
			scheduled_labour_hours: '',
			scheduled_labour_cost: '',
			actual_labour_hours: '',
			actual_labour_cost: '',
			total_leaves: '',
			total_absents: '',
			total_late: '',
			total_weekly_off: '',
			total_overtime: '',
			total_early_out: '',
		},
		is_loggedIn: false
		// upload_csv_dialog: false
	},
	getters: {
		// getSalesTable(state) {
		// 	return state.salesTable;
		// }
	},
	mutations: {
		// addRowsToSalesTable(state, payload) {
		// 	state.salesTable.data.rows = payload;
		// },
		openLoginModel(state, payload) {
			state.show_login_and_freeTrial_model = payload;
		},
		showFreeTrialModel(state, payload) {
			state.toggle_login_and_freeTrial_tab = payload;
		},
		StoreEmail(state, payload) {
			state.store_email = payload;
		},
		appendUserRegistrationDetails(state, payload) {
			(state.userRegistration.company_name = payload.company_name),
				(state.userRegistration.Address1 = payload.Address1),
				(state.userRegistration.Address2 = payload.Address2),
				(state.userRegistration.selected_country = payload.selected_country),
				(state.userRegistration.selected_state = payload.selected_state),
				(state.userRegistration.selected_city = payload.selected_city),
				(state.userRegistration.selected_sector = payload.selected_sector),
				(state.userRegistration.other_company_sector =
					payload.other_company_sector),
				(state.userRegistration.zip_code = payload.zip_code),
				(state.userRegistration.contact_number = payload.contact_number),
				(state.userRegistration.start_date = payload.start_date),
				(state.userRegistration.start_date1 = payload.start_date1),
				(state.userRegistration.end_date = payload.end_date),
				(state.userRegistration.more_store = payload.more_store),
				(state.userRegistration.is_single_location =
					payload.is_single_location);
		},
		showAccountType(state, payload) {
			state.acount_type_tab = payload;
		},
		showUserInformation(state, payload) {
			state.user_information_tab = payload;
		},
		showFinishSetup(state, payload) {
			state.finish_setup_tab = payload;
		},
		FilledAllUserInformationData(state, payload) {
			state.filled_user_information = payload;
		},
		FilledAccountType(state, payload) {
			state.filled_account_type = payload;
		},
		// uploadCSVDialog(state, payload) {
		// 	state.upload_csv_dialog = payload;
		// },
		getUserDetails(state, payload) {
			state.loginUserDetails = payload;
		},
		getOutletData(state, payload) {
			state.outletData = payload;
		},
		setActiveTaskTypeTab(state, payload){
			state.active_task_type_tab = payload;
		},
		commitDesignationsList(state, payload){
			state.designations = payload;
		},
		commitTimesheetSummary(state, payload){
			state.timesheet_summary = payload;
		}
	},
	actions: {},
	modules: {
		appSalesTabStore,
		appTableStore,
		CommonStore,
		AppForecastStore,
		UploadCsvStore,
		LabourPlanning,
		AccountsStore,
		TicketsStore,
		SettingStore,
		networkConfig,
		MonthlySchedulerStore,
		TicketDashboardStore,
		UsersAndGroups,
		SalesForecastStore,
		TrainingStore,
		salesForecastStoreV2
	}
});
